import script from "./ProductTransparencyTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductTransparencyTile.vue?vue&type=script&setup=true&lang=ts"

import "./ProductTransparencyTile.vue?vue&type=style&index=0&id=63117096&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63117096"]])

export default __exports__